import { useMemo } from 'react';

import { useLayoutPreference } from 'portal/src/layouts/LayoutPreference/useLayoutPreference';
import AuthenticatedLegacy from 'portal/src/layouts/legacy/AuthenticatedLegacy';
import AuthenticatedNew from 'portal/src/layouts/new/AuthenticatedNew';
import TableProvider from 'portal/src/providers/TableProvider';

import { LayoutPreferenceProvider } from './LayoutPreference/LayoutPreferenceProvider';

/** @deprecated Temporary dual-layout rollout wrapper. Remove when legacy layout is retired. */
const AuthenticatedLayoutSwitch = () => {
  const { useNewLayout } = useLayoutPreference();

  // TODO: remove when the legacy layout is retired
  return (useNewLayout ?? true) ? (
    <AuthenticatedNew />
  ) : (
    <AuthenticatedLegacy />
  );
};

export default function Authenticated() {
  return (
    <TableProvider>
      <LayoutPreferenceProvider>
        <AuthenticatedLayoutSwitch />
      </LayoutPreferenceProvider>
    </TableProvider>
  );
}
